/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { changePage, updatePageDetails } from "@insticator/insticator-ui";
import { setSessionData } from 'state/actions/session_status';
// component
import SignUpComplete from 'pages/auth/signupcomplete/signupcomplete';

/* ========== ~~~~~~~~~~ AUTH SignUpComplete : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ sessionStatus }) => ({
    storedSessionData: sessionStatus.storedSessionData
});

// map actions
const mapDispatchToProps = dispatch => ({
    setSessionData: data => dispatch(setSessionData(data)),
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    }
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SignUpComplete);
